define((require) => {
    "use strict";

    var ActionPropertiesView          = require("ui/experience/action/ActionPropertiesView"),
        AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView"),
        CharacterPropertiesView       = require("ui/experience/widgets/CharacterPropertiesView"),
        ImprovedView                  = require("editor/zbone/ImprovedView"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        template                      = require("ui/experience/widgets/textWidget/TextWidgetPropertiesView.tpl");

    /**
     * The properties view for a text widget.
     *
     * @class TextWidgetPropertiesView
     * @constructor
     *
     * @cfg {TextWidgetModel} model The model for the text widget being edited.
     */
    return ImprovedView.extend({

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            characterProperties: ".character-properties",
            actionProperties: ".action-properties"
        },

        onRender: function() {
            this.__super();

            this.analyticsProperties.show(this._setAnalyticsLabel({model: this.model}));
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                showWidthControls: true,
                hideSizeControls: true,
                widgetView: this.options.widgetView
            }));
            this.characterProperties.show(new CharacterPropertiesView({model: this.model.get("editorModel"), widgetView: this.options.widgetView}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this.actionProperties.show(new ActionPropertiesView({model: this.model}));
        }
    }, {
        EXPAND_PROPERTY: CharacterPropertiesView.EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textWidget/TextWidgetPropertiesView.js